<app-toxicology-expected [orderId]="orderId"></app-toxicology-expected>
<app-toxicology-unexpected-negative [orderId]="orderId"></app-toxicology-unexpected-negative>
<app-toxicology-unexpected-positive [orderId]="orderId" (hasResultEvent)="hasUnexpectedPositiveResults($event)"></app-toxicology-unexpected-positive>
<app-toxicology-other-medications [orderId]="orderId"></app-toxicology-other-medications>
<app-toxicology-alpha [orderId]="orderId"></app-toxicology-alpha>
